import { render, staticRenderFns } from "./ProgramSupportAdmins.vue?vue&type=template&id=4efd7174"
import script from "./ProgramSupportAdmins.vue?vue&type=script&lang=js"
export * from "./ProgramSupportAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports